module.exports = __webpack_public_path__ + "static/media/ico-delete.b9f2605b.svg";